export * from './flex';
export * from './sections';
export * from './section';

export type Gap =
    'normal'
    | 'tight'
    | 'tighter'
    | 'wide'
    | 'wider'
    | 'extra-wide'
    | 'none';

export const gap = (x: Gap): string => {
    switch (x) {
        case 'extra-wide': return 'var(--gap-extra-wide)';
        case 'wider': return 'var(--gap-wider)';
        case 'wide': return 'var(--gap-wide)';
        case 'tight': return 'var(--gap-tight)';
        case 'tighter': return 'var(--gap-tighter)';
        case 'none': return '0';
        case 'normal':
        default: return '1em';
    }
};
